import { render, staticRenderFns } from "./TotalActiveByState.vue?vue&type=template&id=97b823e2&"
import script from "./TotalActiveByState.vue?vue&type=script&lang=js&"
export * from "./TotalActiveByState.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports